export const AppSections = {
  LiveRoom: "liveRoom",
};
